import { useMemo } from 'react'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { priceBookColumns } from './PriceBookFields'

const ListPriceBook = () => {
  const { user } = useAuth()
  const userRight = useOutletContext()

  const options = useMemo(
    () => ({
      objectType: 'priceBooks',
      accessRight: userRight,
      objectFilter: () => ({ company_id: user.company_id }),
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer le tarif',
          field: 'name'
        }
      },
      isFilter: true,
      columns: priceBookColumns
    }),
    [userRight, user.company_id]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'priceBooks',
      title: 'Tarifs',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListPriceBook
